<script setup lang="ts">
    const props = defineProps({
        class: {
            type: [String, Array] as PropType<string | any[]>,
            required: false
        }
    })

</script>

<template>
    <div :class=[props.class]>
        <slot />
    </div>
</template>